import React, { PureComponent } from 'react';
import { PrimaryButton } from 'appSrc/components/UI';
import { VideoImageSelector } from 'appSrc/components/Shards';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import Edit from 'appSrc/components/Icons/Edit';
import { FormTextField, FormToggle } from 'appSrc/components/UI/ReduxForm';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import { dAPI } from 'appSrc/api';
import { debounce } from 'throttle-debounce';
import style from './styles/style.module.css';

class ItemForm extends PureComponent {

    constructor( props ) {
        super( props );

        this.state = {
            selectedImage: this.props.initialValues.cover_image,
        };
    }
    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'cover_image', imageData );
        }
    }

    catchKeyPress = ( e ) => {
        if( e.key == 'Enter' ) {
            e.preventDefault();
        }
    }

    submitHandler = ( values ) => {
        var data = { ...values };
        data.cover_image = this.state.selectedImage;
        this.props.onSubmit( { item: data} );
    }

    render() {
        const { handleSubmit } = this.props;
        const { selectedImage } = this.state;

        return (
            <div>
                <Form className={ style.itemForm }
                onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>
                        <ImageCropModalWrapper
                        aspectRatio={ 30/13 }
                        onFinish={ this.cropFinish }>
                            <div>
                                <img src={ selectedImage } />
                                <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } />Edit Image/Video</span>
                            </div>
                        </ImageCropModalWrapper>
                        <div className={ style.detailsWrapper }>
                            <Field
                            id="title"
                            name="title"
                            label="Title"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="text"
                            name="text"
                            label="Text (eg. Karl Steltenpohl Software Developer)"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="type"
                            name="type"
                            label="Type (eg. Class)"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="url"
                            name="url"
                            label="url"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="content_id"
                            name="content_id"
                            label="Content Id"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="review_id"
                            name="review_id"
                            label="Review Id"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="button_label"
                            name="button_label"
                            label="Button Label"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="context"
                            name="context"
                            label="context"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="sort_order"
                            name="sort_order"
                            label="Sort Order"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="status"
                            name="status"
                            label="Status"
                            component="select"
                            style={ { marginTop: '10px' } }>
                                <option value="draft">Draft</option>
                                <option value="published">Published</option>
                            </Field>

                            { this.props.initialValues.id && <Field
                            id="deactivated"
                            name="deactivated"
                            label="Deactivated"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            /> }

                            <PrimaryButton
                            label="Submit"
                            fullWidth
                            type="submit"
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>

            </div>
        );
    }
}
ItemForm.defaultProps = {
    initialValues: {},
};

ItemForm = reduxForm( {
    form: 'ItemForm',
} )( ItemForm );

const mapStateToProps = ( state ) => {
    return {
        listInterests: state.vars.interests,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'ItemForm', field, value ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ItemForm );
